var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"color":"primary","background-color":"accent","height":"22","value":_vm.interval_relative,"rounded":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.interval_absolute + ' ' + _vm.interval_unit)+" / "+_vm._s(value)+" % ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }